module.exports = __webpack_public_path__ + "img/ds5.4d70502b.png";